export const whiteSpaceOnUndefined = (val?: any) => (val === undefined ? ' ' : val);
